import { So360DownloadCallbackData } from '../config/downloadUrls';
import { DOWNLOAD_CLIENT_TYPE } from '../constant';

const getQueryValue = (query: Record<string, unknown>, key: string): string => {
  const value = query[key];
  if (Array.isArray(value)) {
    return value[0] ? String(value[0]) : '';
  }
  return value ? String(value) : '';
};

export const getbdVidLink = (url: string, bdVid: string, apiToken: string): string => {
  return url.replace('.exe', '') + `&${bdVid}#${apiToken}&` + '.exe';
};

export const get360Link = (
  url: string,
  qhclickId: string,
  data: So360DownloadCallbackData,
): string => {
  return url.replace('.exe', '') + `&${qhclickId}#${data.key}#${data.Secret}#${data.IDX}&` + '.exe';
};

export const getBdVidFromQuery = (query: Record<string, unknown>): string => {
  return getQueryValue(query, 'bdVid') || getQueryValue(query, 'bd_vid');
};

export const getQhclickIdFromQuery = (query: Record<string, unknown>): string => {
  return getQueryValue(query, 'qhclickid') || getQueryValue(query, 'qhclickId');
};

export const getFileNameFromUrl = (url: string): string => {
  return url.split('/').pop() || '';
};

export const resolveDownloadUrl = (
  url: string,
  type: string,
  options: {
    baiduApiToken?: string;
    so360DownloadConfig?: So360DownloadCallbackData;
    query?: Record<string, unknown>;
  } = {},
): string => {
  const { baiduApiToken, so360DownloadConfig, query = {} } = options;
  if (type !== DOWNLOAD_CLIENT_TYPE.PC) {
    return url;
  }
  if (baiduApiToken) {
    const bdVid = getBdVidFromQuery(query);
    if (bdVid) {
      return getbdVidLink(url, bdVid, baiduApiToken);
    }
  }
  if (so360DownloadConfig) {
    const qhclickId = getQhclickIdFromQuery(query);
    if (qhclickId) {
      return get360Link(url, qhclickId, so360DownloadConfig);
    }
  }
  return url;
};

const triggerDownload = (href: string, fileName: string) => {
  const link = document.createElement('a');
  link.href = href;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadResolvedFile = async (
  rawUrl: string,
  type: string,
  options: {
    baiduApiToken?: string;
    so360DownloadConfig?: So360DownloadCallbackData;
    query?: Record<string, unknown>;
  } = {},
) => {
  const resolvedUrl = resolveDownloadUrl(rawUrl, type, options);
  const fileName = getFileNameFromUrl(resolvedUrl);

  if (resolvedUrl === rawUrl) {
    triggerDownload(rawUrl, fileName);
    return;
  }

  // 增加下载中提示：正在下载中，请勿走开哦
  let downloadingToast: HTMLElement | null = null;
  try {
    downloadingToast = document.createElement('div');
    downloadingToast.innerText = '正在下载中, 请勿走开哦';
    downloadingToast.style.position = 'fixed';
    downloadingToast.style.top = '50%';
    downloadingToast.style.left = '50%';
    downloadingToast.style.transform = 'translate(-50%, -50%)';
    downloadingToast.style.background = 'rgba(0, 0, 0, 0.8)';
    downloadingToast.style.color = '#fff';
    downloadingToast.style.padding = '16px 32px';
    downloadingToast.style.borderRadius = '8px';
    downloadingToast.style.fontSize = '16px';
    downloadingToast.style.zIndex = '9999';
    document.body.appendChild(downloadingToast);

    const response = await fetch(rawUrl);
    if (!response.ok) {
      throw new Error('download failed');
    }
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    triggerDownload(blobUrl, fileName);
    URL.revokeObjectURL(blobUrl);
    if (downloadingToast) {
      document.body.removeChild(downloadingToast);
    }
  } catch {
    if (downloadingToast) {
      document.body.removeChild(downloadingToast);
    }
    triggerDownload(rawUrl, fileName);
  }
};
